/*
  NordiskPuls - gave-popup
  =================================================================
  TRE SKAERME I EEN: indpakket gave -> "aabner din gave..." -> afsloering.
  Kunden faar foerst at vide HVAD hun faar, naar mailen er skrevet.

  ALT INDHOLD KOMMER FRA METAFELTERNE
  Produktnavn, gavens navn, gavens pris og farvebillederne laeses fra
  #NPSideGave (se np-kurv-extras.liquid). Intet af det staar i denne fil.
  Skriver man "Pulsen Pro" eller "49 kr" ind i teksten her, holder det op
  med at passe i samme oejeblik der saettes en gave paa et andet produkt -
  og saa er hele pointen med den metafelt-drevne opsaetning vaek.

  "GAELDER VED KOEB AF ..." SKAL STAA PAA FOERSTE SKAERM
  Gaven er kun gratis i kraft af en ordrerabat, og rabatten kraever at
  udloeser-produktet er i kurven. Staar betingelsen foerst paa
  afsloeringsskaermen, foeles den som en hage der blev skjult med vilje.

  AESKEN ER SPAN'ER, IKKE DIV'ER
  Temaets base.css har "div:empty { display: none }". Aeskens dele er
  tomme - de er ren CSS - saa som div'er forsvinder underdelen af gaven
  helt lydloest. Der er ogsaa et eksplicit display: block i CSS'en.

  RAEKKEFOELGEN I KLIKKET ER DET VIGTIGSTE I FILEN
  1. Gaven i kurven  (ren Shopify, intet eksternt netvaerk)
  2. Tilmelding til Klaviyo  (fire-and-forget)
  Fejler 2, har kunden stadig sin gave. Omvendt raekkefoelge ville betyde
  at en blokeret adblocker-bruger mistede baade mail OG gave.
*/
(function () {
  'use strict';

  var VIST = 'np_gavepopup_vist_';
  var NOEGLE_MAIL = 'np_gave_mail_adresse';
  var FORSINKELSE = 5000;
  var AABNETID = 650;     // anticipation-beat foer afsloeringen

  var KL_NOEGLE = 'VV2NiG';        // offentlig site-ID, maa gerne staa i klartekst
  var KL_LISTE = 'W2fiGs';         // "Email List"
  var KL_REVISION = '2026-07-15';
  var KL_KILDE = 'Produktgave';

  function sideGave() {
    var el = document.getElementById('NPSideGave');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Navne kommer fra metafelter og saettes ind med innerHTML.
  // Et & eller en < i et produktnavn maa ikke kunne bryde markup'en.
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Popup'en spoerger IKKE om hun har ret til gaven - den spoerger om hun
  // har svaret i DETTE besoeg. Retten (npGaveFlag.har) er permanent og
  // hoerer til motoren; havde popup'en brugt den, ville en kunde der gav
  // sin mail men aldrig koebte, aldrig se tilbuddet igen. Se np-gaveflag.js.
  function harTagetImod() {
    return !!(window.npGaveFlag && window.npGaveFlag.svaretNu());
  }
  // Ligger i np-gaveflag.js, saa popup'en og motoren laeser det samme svar.
  function erAfvist(u) {
    return !!(window.npGaveAfvist && window.npGaveAfvist.er(u));
  }
  function alleredeVist(u) {
    try { return sessionStorage.getItem(VIST + u) === '1'; } catch (e) { return true; }
  }
  function markerVist(u) {
    try { sessionStorage.setItem(VIST + u, '1'); } catch (e) {}
  }

  function kendtMail() {
    if (window.npKundeMail) return String(window.npKundeMail);
    try { return localStorage.getItem(NOEGLE_MAIL) || ''; } catch (e) { return ''; }
  }
  function gemMail(m) {
    try { localStorage.setItem(NOEGLE_MAIL, m); } catch (e) {}
  }

  // Bevidst loes: en regex kan ikke afgoere om en mail findes, kun om den
  // er aabenlyst forkert. Alt strengere afviser rigtige adresser.
  function gyldig(m) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(m);
  }

  // Klaviyos client-side endpoint. Kraever KUN den offentlige noegle og
  // rammer ikke onsite-scriptet, saa adblockere staar ikke i vejen.
  // Content-Type SKAL vaere application/vnd.api+json - med almindelig
  // application/json afviser Klaviyo kaldet.
  function tilmeld(mail) {
    var krop = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: KL_KILDE,
          profile: { data: { type: 'profile', attributes: {
            email: mail,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: KL_LISTE } } }
      }
    };
    try {
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + KL_NOEGLE, {
        method: 'POST',
        headers: { 'revision': KL_REVISION, 'Content-Type': 'application/vnd.api+json' },
        body: JSON.stringify(krop),
        keepalive: true
      }).then(function (r) {
        if (!r.ok) console.warn('[NP gave] tilmelding afvist: ' + r.status);
      }).catch(function () { /* kunden har sin gave - vi mistede kun mailen */ });
    } catch (e) {}
  }

  function spor(gave, mail) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function' && mail) {
        window.klaviyo.identify({ $email: mail });
      }
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track('Gave modtaget', {
          GaveTitel: gave ? gave.titel : '',
          UdloeserProduktId: gave ? gave.udloeser : ''
        });
      }
    } catch (e) {}
  }

  function aabnKurv(forsinkelse) {
    setTimeout(function () {
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') d.open();
    }, forsinkelse || 300);
  }

  // Ruller ned til koebsknappen. Naar kurven er tom, er "se min kurv"
  // det forkerte naeste skridt - hun skal vaelge sin Pulsen foerst.
  function rulTilKoeb() {
    var k = document.querySelector('.product-form__submit, [name="add"]');
    var maal = k && (k.closest('product-form, .product__info-container') || k);
    if (maal && maal.scrollIntoView) {
      maal.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  /* ---------- Hvad staar der faktisk i kurven? ----------
     Motoren lagger gaven i asynkront. Spoerger vi for tidligt, ser vi en
     kurv uden gave og ville sige "den ligger i din kurv" om noget der
     ikke er der. Derfor ventes der - men kun hvis udloeseren overhovedet
     ER i kurven. Er den ikke, er der intet at vente paa. */
  function ventPaaGave(gave, maxMs) {
    var start = Date.now();
    return new Promise(function (svar) {
      (function prov() {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (k) {
            var linjer = k.items || [];
            var harGave = linjer.some(function (i) {
              return i.properties && String(i.properties._gavetype) === String(gave.udloeser);
            });
            var harUdloeser = linjer.some(function (i) {
              return String(i.product_id) === String(gave.udloeser);
            });
            if (harGave) return svar({ gave: true, udloeser: true });
            if (!harUdloeser) return svar({ gave: false, udloeser: false });
            if (Date.now() - start > maxMs) return svar({ gave: false, udloeser: true });
            setTimeout(prov, 400);
          })
          .catch(function () { svar({ gave: false, udloeser: false }); });
      })();
    });
  }

  /* ---------- Den flydende gave-knap ----------
     Lukker kunden popup'en uden at svare, mistede vi foer gaven for hele
     besoeget. Knappen lader hende sige "ikke lige nu" uden at det koster
     noget. Efter "Nej tak" vises den ikke paa DENNE sidevisning - svaret
     skal respekteres i oejeblikket - men den er der igen naeste gang
     kunden aabner en produktside med gaven. Se maaskePille() nederst. */
  function bundAfstand() {
    // Der kan ligge en sticky koebsbjaelke eller en chat-widget forneden.
    // Vi maaler dem i stedet for at gaette en afstand der alligevel
    // flytter sig naeste gang nogen redigerer temaet.
    //
    // MAALT 23/9: den foerste udgave gik hele DOM'en igennem med
    // getComputedStyle paa hvert element. Paa produktsiden er der 4.004
    // elementer, og det kostede 17-57 ms PR. KALD - bundet til scroll.
    // Det stammede scrollen mens gave-knappen var fremme.
    // elementsFromPoint spoerger browseren hvad der rent faktisk ligger i
    // bunden af skaermen. Det er O(dybde) i stedet for O(alle elementer),
    // og det er praecis det spoergsmaal vi stiller.
    var vh = window.innerHeight, vw = window.innerWidth, h = 0;
    var stak = document.elementsFromPoint(Math.round(vw / 2), vh - 2) || [];
    for (var i = 0; i < stak.length; i++) {
      var e = stak[i];
      if (!e || e === document.body || e === document.documentElement) continue;
      if (e.closest('.np-gavepop, .np-gavepille')) continue;
      var c = window.getComputedStyle(e);
      if (c.position !== 'fixed' || c.display === 'none' || c.visibility === 'hidden') continue;
      var b = e.getBoundingClientRect();
      if (b.height < 8 || b.height > vh * 0.5) continue;
      if (Math.abs(b.bottom - vh) > 6) continue;         // ikke forankret i bunden
      if (b.width < vw * 0.5) continue;                  // smal widget staar ved siden af
      if (b.height > h) h = b.height;
    }
    return Math.round(h);
  }

  function visPille(gave) {
    if (document.querySelector('.np-gavepille')) return;
    var p = document.createElement('button');
    p.type = 'button';
    p.className = 'np-gavepille';
    p.setAttribute('aria-label', 'Aabn din gratis gave');
    p.innerHTML = '<span class="np-gavepille__ikon" aria-hidden="true"></span><span>Gratis gave</span>';
    document.body.appendChild(p);

    // Selv en billig maaling skal ikke koere 60 gange i sekundet under
    // scroll. rAF samler dem til een pr. billede.
    var venter = false;
    function placer() {
      if (venter) return;
      venter = true;
      requestAnimationFrame(function () {
        venter = false;
        p.style.bottom = (bundAfstand() + 14) + 'px';
      });
    }
    p.style.bottom = (bundAfstand() + 14) + 'px';
    window.addEventListener('resize', placer);
    window.addEventListener('scroll', placer, { passive: true });

    setTimeout(function () { p.classList.add('er-inde'); }, 40);
    p.addEventListener('click', function () {
      p.remove();
      window.removeEventListener('resize', placer);
      window.removeEventListener('scroll', placer);
      byg(gave);
    });
  }

  /* Haengelaasen i CTA'en. Samme guld som gavens belysning, saa knappen
     siger "her laases noget op" uden et eneste ekstra ord. */
  var LAAS =
    '<svg class="np-gavepop__laas" viewBox="0 0 24 26" aria-hidden="true" focusable="false">' +
      '<path d="M7.6 11.6V8.4a4.4 4.4 0 0 1 8.8 0v3.2" fill="none" stroke="#F3CE79" stroke-width="2.5" stroke-linecap="round"/>' +
      '<rect x="4.3" y="11.4" width="15.4" height="12.2" rx="3" fill="#FFD76A"/>' +
      '<rect x="4.3" y="11.4" width="15.4" height="4.4" rx="2.2" fill="#FFE9A8"/>' +
      '<circle cx="12" cy="16.8" r="2" fill="#8A6212"/>' +
      '<path d="M11.15 17.3h1.7l.45 3.2h-2.6z" fill="#8A6212"/>' +
      '<path d="M21.3 3.9l.75 2.15 2.15.75-2.15.75-.75 2.15-.75-2.15L18.4 6.8l2.15-.75z" fill="#FFF3CE"/>' +
    '</svg>';

  /* Guldmaerket paa gaven. Inline SVG, ikke et billede: det skal vaere
     skarpt i alle stoerrelser, og teksten skal kunne oversaettes. */
  var BADGE =
    '<svg class="np-gave__badge" viewBox="0 0 100 100" aria-hidden="true" focusable="false">' +
      '<path fill="#FCFAF4" stroke="#DFC482" stroke-width="1.8" d="M94.0 50.0A9.1 9.1 0 0 1 90.7 66.8A9.1 9.1 0 0 1 81.1 81.1A9.1 9.1 0 0 1 66.8 90.7A9.1 9.1 0 0 1 50.0 94.0A9.1 9.1 0 0 1 33.2 90.7A9.1 9.1 0 0 1 18.9 81.1A9.1 9.1 0 0 1 9.3 66.8A9.1 9.1 0 0 1 6.0 50.0A9.1 9.1 0 0 1 9.3 33.2A9.1 9.1 0 0 1 18.9 18.9A9.1 9.1 0 0 1 33.2 9.3A9.1 9.1 0 0 1 50.0 6.0A9.1 9.1 0 0 1 66.8 9.3A9.1 9.1 0 0 1 81.1 18.9A9.1 9.1 0 0 1 90.7 33.2A9.1 9.1 0 0 1 94.0 50.0Z"/>' +
      '<path fill="#DFB259" d="M50 21 L53.4 32.6 L65 36 L53.4 39.4 L50 51 L46.6 39.4 L35 36 L46.6 32.6 Z"/>' +
      '<text x="50" y="62" text-anchor="middle" font-size="17.5" font-weight="700" fill="#1E547D">100%</text>' +
      '<text x="50" y="76" text-anchor="middle" font-size="12" font-weight="600" letter-spacing="0.6" fill="#2C71A7">GRATIS</text>' +
    '</svg>';

  /* ---------- Selve popup'en ---------- */
  function byg(gave) {
    var mail = kendtMail();
    var udloeser = esc(gave.udloeserTitel || 'produktet');
    var farver = (gave.farver && gave.farver.length) ? gave.farver : (gave.billede ? [gave.billede] : []);

    var o = document.createElement('div');
    o.className = 'np-gavepop';
    o.innerHTML =
      '<div class="np-gavepop__bag"></div>' +
      '<div class="np-gavepop__kort" role="dialog" aria-modal="true" aria-label="En gratis gave venter paa dig">' +
        // NP (5/10): kryds oeverst til hoejre. Lukker som et klik paa baggrunden (gaven afvises IKKE, og "Gratis gave"-knappen kommer frem).
        '<button type="button" class="np-gavepop__luk" aria-label="Luk"><svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3.5 3.5l9 9M12.5 3.5l-9 9" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>' +
        '<div class="np-gavepop__scene">' +
          '<span class="np-straaler"></span>' +
          '<span class="np-gaveboks__glimt"></span>' +
          '<span class="np-gnist np-gnist--1"></span>' +
          '<span class="np-gnist np-gnist--2"></span>' +
          '<span class="np-gnist np-gnist--3"></span>' +
          '<span class="np-gnist np-gnist--4"></span>' +
          '<span class="np-gnist np-gnist--5"></span>' +
          '<span class="np-gnist np-gnist--6"></span>' +
          // Gaven er et billede. En 3D-gave med glans og rigtig sloejfe
          // kan ikke tegnes i CSS. Filnavnet kommer fra Liquid, saa den
          // kan skiftes ud uden at roere denne fil.
          '<div class="np-gave">' +
            '<img class="np-gave__bil" src="' + esc(window.npGaveBillede || '') + '" alt="" ' +
              'width="1080" height="1080" decoding="async">' +
            BADGE +
          '</div>' +
          '<div class="np-gavepop__praemie">' +
            farver.slice(0, 4).map(function (src, n) {
              return '<img class="np-praemie__kort np-praemie__kort--' + (n + 1) + '" src="' + esc(src) + '" alt="">';
            }).join('') +
          '</div>' +
        '</div>' +
        '<div class="np-gavepop__tekstdel">' +
          '<h2 class="np-gavepop__titel">En gratis gave<span>venter p&aring; dig</span></h2>' +
          '<p class="np-gavepop__tekst">Afsl&oslash;r din gave til ' + udloeser + '</p>' +
          '<input type="email" id="npGaveMailFelt" class="np-gavepop__felt" ' +
            'name="email" autocomplete="email" inputmode="email" ' +
            'spellcheck="false" autocapitalize="off" ' +
            'aria-label="Din mail" placeholder="Din mail" value="' + esc(mail) + '">' +
          '<p class="np-gavepop__fejl" role="alert"></p>' +
          '<button type="button" class="np-gavepop__ja np-gavepop__ja--pil">' + LAAS + 'Afsl&oslash;r min gave</button>' +
          // Haard mellemrum foer bindestregen: uden det kan linjen braekke
          // saadan at bindestregen starter linje to, og det ser forkert ud.
          '<p class="np-gavepop__vilkaar">Ved at forts&aelig;tte tilmelder du dig ' +
            'vores nyhedsbrev&nbsp;- du kan altid afmelde igen.</p>' +
          '<button type="button" class="np-gavepop__nej">Nej tak</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(o);

    // IKKE requestAnimationFrame: den koerer ikke i en baggrundsfane.
    // Aabner kunden produktsiden i en ny fane og skifter til den bagefter,
    // ville popup'en vaere bygget men usynlig for altid.
    setTimeout(function () { o.classList.add('er-aaben'); }, 20);

    var scene = o.querySelector('.np-gavepop__scene');
    var tekstdel = o.querySelector('.np-gavepop__tekstdel');
    var felt = o.querySelector('.np-gavepop__felt');
    var fejl = o.querySelector('.np-gavepop__fejl');
    var ja = o.querySelector('.np-gavepop__ja');
    var afsloeret = false;

    function fjern() {
      o.classList.remove('er-aaben');
      setTimeout(function () { o.remove(); }, 250);
    }
    // Luk uden at svare -> gaven bliver tilgaengelig i pillen.
    function lukUdenSvar() {
      fjern();
      if (!afsloeret) setTimeout(function () { visPille(gave); }, 280);
    }

    function visFejl(t) {
      fejl.textContent = t;
      fejl.classList.add('er-vist');
      felt.classList.add('er-fejl');
    }

    // Teksterne siger "gaven", ikke "coveret" og ikke "den". Gavens navn
    // kommer fra et metafelt, saa vi kan hverken kende produkttypen eller
    // om ordet er et eller en. "Gaven" passer paa alt.
    function afsloer(status) {
      afsloeret = true;
      var brodtekst, knaptekst, knapklasse;
      if (status.gave) {
        brodtekst = 'Din gave er allerede lagt i kurven.';
        knaptekst = 'Se min kurv';
        knapklasse = 'np-gavepop__kurv';
      } else if (status.udloeser) {
        brodtekst = 'Vi l&aelig;gger gaven i kurven sammen med din ' + udloeser + '.';
        knaptekst = 'Se min kurv';
        knapklasse = 'np-gavepop__kurv';
      } else {
        brodtekst = 'Vi l&aelig;gger gaven automatisk i kurven, n&aring;r du l&aelig;gger en ' + udloeser + ' i.';
        knaptekst = 'V&aelig;lg min ' + udloeser;
        knapklasse = 'np-gavepop__koeb';
      }

      tekstdel.innerHTML =
        '<p class="np-gavepop__laastop">Din gave er l&aring;st op</p>' +
        '<h2 class="np-gavepop__titel np-gavepop__titel--gave">Gratis ' + esc(gave.titel) + '</h2>' +
        (gave.prisTekst
          ? '<p class="np-gavepop__pris"><s>' + esc(gave.prisTekst) + '</s><span>Gratis</span></p>'
          : '') +
        '<p class="np-gavepop__tekst">' + brodtekst + '</p>' +
        '<button type="button" class="np-gavepop__ja ' + knapklasse + '">' + knaptekst +
          ' <span aria-hidden="true">&rarr;</span></button>' +
        '<p class="np-gavepop__note">Du v&aelig;lger farve i kurven.</p>';

      var k = tekstdel.querySelector('.np-gavepop__kurv');
      if (k) k.addEventListener('click', function () { fjern(); aabnKurv(200); });
      var b = tekstdel.querySelector('.np-gavepop__koeb');
      if (b) b.addEventListener('click', function () { fjern(); setTimeout(rulTilKoeb, 220); });
      tekstdel.style.minHeight = '';
    }

    function send() {
      var m = String(felt.value || '').trim().toLowerCase();
      if (!gyldig(m)) {
        visFejl(m ? 'Mailen ser ikke rigtig ud' : 'Skriv din mail');
        felt.focus();
        return;
      }
      ja.disabled = true;
      felt.blur();   // laegger tastaturet ned paa mobil, saa afsloeringen kan ses

      // 1. Gaven foerst. Intet herunder maa kunne forhindre den.
      gemMail(m);
      if (typeof window.npGaveMail === 'function') window.npGaveMail();

      // 2. Derefter Klaviyo, uden at noget venter paa svaret.
      tilmeld(m);
      spor(gave, m);

      // 3. Aesken aabner sig, og teksten bliver til et kort
      //    "aabner din gave..." - saa afsloeringen faar et oejeblik at
      //    lande i, i stedet for at facit staar der med det samme.
      scene.classList.add('er-aabnet');
      // Laas hoejden mens "aabner din gave..." staar der. Uden den falder
      // kortet sammen til en enkelt linje og vokser igen et halvt sekund
      // efter - to ryk paa under et sekund, lige der hvor oplevelsen skal
      // foeles rolig.
      tekstdel.style.minHeight = tekstdel.offsetHeight + 'px';
      tekstdel.innerHTML = '<p class="np-gavepop__aabner">&Aring;bner din gave&hellip;</p>';

      Promise.all([
        ventPaaGave(gave, 3000),
        new Promise(function (r) { setTimeout(r, AABNETID); })
      ]).then(function (svar) { afsloer(svar[0]); });
    }

    ja.addEventListener('click', send);
    felt.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); send(); }
    });
    felt.addEventListener('input', function () {
      fejl.classList.remove('er-vist');
      felt.classList.remove('er-fejl');
    });

    // "Nej tak" er et svar: popup'en afbryder ikke igen i 2 timer.
    // Men knappen kommer stadig frem - bare med en pause, saa det ikke
    // foeles som en indvending mod hendes svar. Uden den skulle hun
    // genindlaese siden for at finde gaven igen, hvis hun fortryder ti
    // sekunder senere, og det goer ingen.
    o.querySelector('.np-gavepop__nej').addEventListener('click', function () {
      if (typeof window.npGaveAfvis === 'function') window.npGaveAfvis(gave.udloeser);
      afsloeret = true;
      fjern();
      setTimeout(function () { visPille(gave); }, 2500);
    });
    o.querySelector('.np-gavepop__bag').addEventListener('click', lukUdenSvar);
    o.querySelector('.np-gavepop__luk').addEventListener('click', lukUdenSvar);
    // Uden krydset er Escape den eneste udvej for den der ikke bruger mus.
    function paaEsc(e) {
      if (e.key !== 'Escape') return;
      document.removeEventListener('keydown', paaEsc);
      lukUdenSvar();
    }
    document.addEventListener('keydown', paaEsc);
  }

  /* VEJEN TILBAGE TIL GAVEN MAA ALDRIG LUKKE SIG
     Popup'en afbryder hoejst een gang pr. besoeg - ogsaa efter hun har
     givet sin mail, for svaret paa DET spoergsmaal lever kun i denne fane
     (npGaveFlag.svaretNu). Men "vi afbryder ikke
     igen" er ikke det samme som "gaven findes ikke mere". Foer forsvandt
     baade popup og pille i det oejeblik kunden klikkede videre til en
     anden side: lukkede hun popup'en kl. 14 og var klar til at koebe
     kl. 21, var der intet spor af gaven tilbage - og saa staar hun med en
     halv beslutning og koeber maaske slet ikke.

     Derfor: naar popup'en IKKE skal vises, vises den flydende gave-knap i
     stedet. Den blokerer ingenting, og et klik paa den aabner popup'en
     igen. Det gaelder ogsaa efter "Nej tak" - svaret stopper afbrydelsen
     i 2 timer (se np-gaveflag.js), ikke adgangen til gaven. */

  function skalAfbryde(gave) {
    return !erAfvist(gave.udloeser) && !alleredeVist(gave.udloeser);
  }

  // 1,8 sek: tidligt nok til at knappen er der naar kunden er faerdig med
  // at scrolle det foerste skaermbillede igennem, sent nok til ikke at
  // konkurrere med produktsidens egne billeder.
  function maaskePille() {
    var gave = sideGave();
    if (!gave || harTagetImod()) return;
    if (skalAfbryde(gave)) return;           // popup'en kommer om lidt
    visPille(gave);
  }

  function maaske() {
    var gave = sideGave();
    if (!gave) return;                       // produktet har ingen gave
    if (harTagetImod()) return;              // kunden har allerede taget imod
    if (!skalAfbryde(gave)) return;          // pillen er vist i stedet
    markerVist(gave.udloeser);
    byg(gave);
  }

  // Til test: npGavePopupNu() viser popup'en, npGavePilleNu() pillen.
  window.npGavePopupNu = function () {
    var g = sideGave();
    if (g) byg(g); else console.warn('[NP gave] produktet har ingen gave');
  };
  window.npGavePilleNu = function () {
    var g = sideGave();
    if (g) visPille(g);
  };

  /* Popup'en bygges foerst ved 5 sek, og foerst DA blev gavebilledet hentet -
     derfor kom gaven halvandet sekund efter resten af kortet. Vi henter den
     forud, men ikke med det samme: ved 1,2 sek er produktsidens egne
     billeder hentet, saa vi ikke stjaeler baandbredde fra dem. */
  function forudhent() {
    if (!window.npGaveBillede) return;
    var i = new Image();
    i.decoding = 'async';
    i.src = window.npGaveBillede;
  }
  setTimeout(forudhent, 1200);

  setTimeout(maaskePille, 1800);
  setTimeout(maaske, FORSINKELSE);
})();
